module.exports = __webpack_public_path__ + "img/pethouse30.0e5f461b.jpg";